import { render, staticRenderFns } from "./question-box.vue?vue&type=template&id=6c26d705&scoped=true&"
import script from "./question-box.js?vue&type=script&lang=js&"
export * from "./question-box.js?vue&type=script&lang=js&"
import style0 from "./question-box.scss?vue&type=style&index=0&id=6c26d705&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c26d705",
  null
  
)

export default component.exports